import React from 'react'
import './Hero.css'

function Hero() {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title fade-in-up">
            You dream all day,<br />
            <span className="gradient-text">AllNightAI codes all night</span>
          </h1>
          <p className="hero-description fade-in-up">
            Autonomous development workflows that work while you sleep.
            Seamlessly integrate with Cursor, VS Code, and Windsurf for
            continuous AI-powered development.
          </p>
          <div className="hero-cta fade-in-up">
            <a href="#download" className="btn btn-primary">
              Get Started
            </a>
            <a href="#features" className="btn btn-secondary">
              Learn More
            </a>
          </div>
          <div className="hero-demo fade-in">
            <div className="demo-window">
              <div className="demo-header">
                <div className="demo-buttons">
                  <span className="demo-btn red"></span>
                  <span className="demo-btn yellow"></span>
                  <span className="demo-btn green"></span>
                </div>
                <div className="demo-title">AllNightAI</div>
              </div>
              <div className="demo-content">
                <div className="demo-sidebar">
                  <div className="demo-item active">
                    <div className="demo-icon">📁</div>
                    <div className="demo-text">my-project</div>
                  </div>
                  <div className="demo-item">
                    <div className="demo-icon">🎯</div>
                    <div className="demo-text">Requirements</div>
                  </div>
                  <div className="demo-item">
                    <div className="demo-icon">🤖</div>
                    <div className="demo-text">Auto Mode</div>
                  </div>
                </div>
                <div className="demo-main">
                  <div className="demo-code-line">
                    <span className="demo-line-number">1</span>
                    <span className="demo-code">
                      <span className="code-comment">// Autonomous development in progress...</span>
                    </span>
                  </div>
                  <div className="demo-code-line">
                    <span className="demo-line-number">2</span>
                    <span className="demo-code">
                      <span className="code-keyword">const</span> <span className="code-var">feature</span> = <span className="code-keyword">await</span> <span className="code-function">implement</span>()
                    </span>
                  </div>
                  <div className="demo-code-line">
                    <span className="demo-line-number">3</span>
                    <span className="demo-code">
                      <span className="code-keyword">await</span> <span className="code-function">runTests</span>()
                    </span>
                  </div>
                  <div className="demo-code-line typing">
                    <span className="demo-line-number">4</span>
                    <span className="demo-code">
                      <span className="code-keyword">await</span> <span className="code-function">commit</span>(<span className="code-string">"Add new feature"</span>)
                    </span>
                    <span className="cursor-blink">|</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
